const startGallerySearchable = () => {
	const form = document.querySelector('.gallery form')

	if (form) {
		const items = document.querySelector('.gallery .images')

		const changeCategory = category => {
			const data = new FormData(form)
			data.append('action', 'gallery_fetch_images')

			// update images
			fetch(OA_AJAX.ajax_url, {
				method: 'POST',
				body: data
			})
			.then(response => {
				if (!response.ok) {
					throw new Error('Network response was not ok')
				}

				return response.json()
			})
			.then(data => {
				items.innerHTML = data.data.html
			})
			.catch(error => {
				console.error('Error:', error)
			})

			// update select if needed
			if (form.category.value != category) form.category.value = category

			// update hero
			const hero = document.querySelector('.hero img')

			if (hero) {
				hero.srcset = ''
				hero.src = form.category.options[form.category.selectedIndex].dataset.hero
			}
		}

		// on load check
		const params = new URLSearchParams(window.location.search)
		const category = params.get('category')

		// if (category) changeCategory(category)
		if (form.category.value != category) form.category.value = category

		// change listener
		form.category.addEventListener('change', e => {
			// fetch images
			const category = e.target.value

			changeCategory(category)
		})
	}
}
startGallerySearchable()
